import styled from 'styled-components'
import {TextField} from '@mui/material'
import {ThemeColorsHospitalic} from '@/assets/styles/color/ThemeColorsHospitalic'

const StyledTextField = styled(TextField)`
    & label {
        color: ${ThemeColorsHospitalic.TEXT_PRIMARY};
    }
`

export default StyledTextField